import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'lib/trpcClient';
import { CalendarDay } from 'further-ui/utils';

export function useGetExitStatementSampleUrl() {
  const utils = api.useUtils();
  const queryClient = useQueryClient();

  const {
    mutate: getSampleUrl,
    mutateAsync: getSampleUrlAsync,
    isPending,
  } = useMutation({
    mutationFn: async ({
      exitId,
      exitAmendmentId,
      data,
      previewPdf = true,
    }: {
      exitId: string;
      exitAmendmentId?: string;
      data: {
        title: string;
        summary: string;
        letter: string;
        notes?: string;
        supportingFiles?: Array<{
          name: string;
          path: string;
        }>;
        statementDate: Date;
        includePreviousExitStatements?: boolean;
      };
      previewPdf?: boolean;
    }) => {
      const result = await utils.exitStatement.getSampleUrl.fetch({
        exitId,
        exitAmendmentId,
        data: {
          title: data.title,
          summary: data.summary,
          letter: data.letter,
          notes: data.notes,
          supportingFiles: data.supportingFiles,
          statementDate: new CalendarDay(data.statementDate),
          notifyInvestors: false,
          includePreviousExitStatements: data.includePreviousExitStatements,
        },
        previewPdf,
      });
      return { sampleUrl: result.sampleUrl, previewPdf };
    },
    onSuccess: async ({ sampleUrl, previewPdf }) => {
      if (previewPdf) {
        window.open(sampleUrl, '_blank');
      } else {
        // Invalidate the investor-reporting query when saving as draft
        await queryClient.invalidateQueries({
          queryKey: ['investor-reporting'],
        });
      }
      // If previewPdf is false, the caller should handle the redirect
    },
  });

  return { getSampleUrl, getSampleUrlAsync, isPending };
}
